import { Body, SectionTitle } from "@sprout/typography.tsx";
import AiMagicIcon from "@sprout/icons/ai_magic.tsx";
import useTranslation from "@hooks/use_translation.ts";
import { type JobDescriptionSummary, joinSummary } from "@/utils/job_description_summary.ts";

type Props = {
  summary?: JobDescriptionSummary | null;
};

const PanelSummary = ({ summary }: Props) => {
  const { t } = useTranslation("jobSearch");

  const text = joinSummary(summary);
  if (!text) return null;

  return (
    <div
      data-provides="job-summary"
      className="flex flex-col gap-2 rounded-lg border border-solid border-[var(--gray-700)] bg-[var(--smoke-gray)] p-4 my-4"
    >
      <div className="flex flex-row items-center gap-2">
        <AiMagicIcon />
        <SectionTitle>{t("summary.heading")}</SectionTitle>
        <Body light as="span">
          &middot; {t("summary.attribution")}
        </Body>
      </div>
      <Body>{text}</Body>
    </div>
  );
};

export default PanelSummary;
